<checkout-header [host]="host" [cart]="cart"
                 [step]="getNextStep()"
                 (back)="back()" (next)="next()" [canProceed]="canProceed()"></checkout-header>

<main class="container" *ngIf="cart && menu">

  <div *ngIf="showModeSelection()">

    <h5 class="mt-3"><i class="fa fa-shipping-fast"></i>&nbsp;<span i18n>Choose takeout or delivery</span></h5>

    <p i18n>
      Do you want to get your order delivered, or do you want to pick it up at the restaurant?
    </p>

    <div class="list-group">
      <a href="#" class="list-group-item list-group-item-action is-clickable ordermethod-takeout"
         [class.active]="cart.method==OrderMethod.takeout" (click)="setMode(OrderMethod.takeout)">
        <div class="row">
          <div class="col">
            <h6 class="mb-1">
              <check-circle [active]="cart.method==OrderMethod.takeout"></check-circle>
              &nbsp;<span i18n>Takeout</span></h6>
            <p class="mb-1" i18n>Pick up your purchase at {{host.address}}</p>
            <discount-entry *ngFor="let entry of takeout_discounts"
                            [entry]="entry"></discount-entry>
          </div>
        </div>
      </a>
      <a href="#" class="list-group-item list-group-item-action is-clickable ordermethod-delivery"
         [class.active]="cart.method==OrderMethod.delivery" (click)="setMode(OrderMethod.delivery)">
        <div class="row">
          <div class="col">
            <h6 class="mb-1">
              <check-circle [active]="cart.method==OrderMethod.delivery"></check-circle>
              &nbsp;<span i18n>Delivery</span>
            </h6>
            <p class="mb-1" i18n>Get food and drinks delivered to your home.</p>
            <discount-entry *ngFor="let entry of delivery_discounts"
                            [entry]="entry"></discount-entry>
          </div>
        </div>
      </a>
    </div>
  </div>
  <div *ngIf="showAddressEntry()">
    <h5 class="mt-3">
      <i class="fa fa-house-user"></i>&nbsp;<span i18n>Delivery Address</span>
    </h5>

    <form class="t4d-form" [formGroup]="form" (ngSubmit)="onFormSubmit()">

      <min-amount-warning [result]="cart.checkMinOrderAmount()" [host]="host" *ngIf="form.valid"></min-amount-warning>

      <div class="form-group mt-2">
        <label for="id_address" i18n>Street and Number*</label>
        <input id="id_address" type="text" class="form-control" autocomplete="street-address" required
               formControlName="address">
      </div>
      <div class="form-group">
        <label for="id_city" i18n>City*</label>
        <select id="id_city" class="form-control" required formControlName="city">
          <option *ngFor="let c of host.delivery_cities" [ngValue]="c.id">{{ (c.zip)? c.city + ' ('+c.zip+')': c.city }}</option>
        </select>
      </div>
    </form>

  </div>

    <p class="mt-3" i18n>
      The order won't be sent right away, you can still review it before submitting.
    </p>

  <div class="mt-2 mb-3 row">
    <div class="col-5 text-left">
      <button class="btn btn-secondary" (click)="back()"><i class="far fa-arrow-alt-circle-left"></i>&nbsp;<span i18n>Back</span></button>
    </div>
    <div class="col-7 text-right">
      <next-step-button [step]="getNextStep()" [enabled]="canProceed()" (next)="next()"></next-step-button>
    </div>
  </div>

</main>
